<template>
  <div class="html_block"
       v-html="content"></div>
</template>

<script>
export default {
  name: "HtmlBlock",
  props: {
    content: {
      type: String,
      default: ''
    }
  }
}
</script>
